import { Component, Input } from '@angular/core';
import { WebArticle } from '../../entities/web-article';

@Component({
  selector: 'app-result-card',
  templateUrl: './result-card.component.html',
  styleUrl: './result-card.component.scss'
})
export class ResultCardComponent {
  @Input() item!: WebArticle;
}
